import { render, staticRenderFns } from "./idCardInfo.vue?vue&type=template&id=42b82ae8&scoped=true&"
import script from "./idCardInfo.vue?vue&type=script&lang=js&"
export * from "./idCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./idCardInfo.vue?vue&type=style&index=0&id=42b82ae8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b82ae8",
  null
  
)

export default component.exports